import { call, put } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";
import { appendProspects, clearSaving, removeProspectFromList, storeCurrentProspect, storeMonthlyReport, storeProspectList, storeTrashProspects, storeUser } from "../../redux/slices/prospectsSlice";

export function* createProspectSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.PROSPECTS.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(appendProspects(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}




export function* listUsersForProspects(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PROSPECTS.USERS_LIST, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeUser(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* listMyProspectSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PROSPECTS.ROUTE, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeProspectList(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


export function* listAllProspectSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PROSPECTS.ALL_LIST, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeProspectList(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* listAllTrashProspectSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PROSPECTS.TRASH, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTrashProspects(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* listMonthlyProspectSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.PROSPECTS.MONTLY_PROSPECT_REPORT, data?.data, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeMonthlyReport(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* getCurrentProspectSaga(action) {
    try {
        const data = action.payload;
        const { id } = data?.data
        const resp = yield call(CallApi.GET, `${API_URLS.PROSPECTS.ROUTE}/${id}`, null, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeCurrentProspect(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            yield put(clearSaving())
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        yield put(clearSaving())
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}

export function* syncCurrentProspectSaga(action) {
    try {
        const data = action.payload;
        const { id, ...itm } = data?.data
        const resp = yield call(CallApi.PATCH, `${API_URLS.PROSPECTS.ROUTE}/${id}`, itm, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeCurrentProspect(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            yield put(clearSaving())
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        yield put(clearSaving())
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}



export function* removeProspectSaga(action) {
    try {
        const data = action.payload;
        const { id } = data?.data
        const resp = yield call(CallApi.DELETE, `${API_URLS.PROSPECTS.ROUTE}/${id}`, null, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(removeProspectFromList(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* removeTrashProspectSaga(action) {
    try {
        const data = action.payload;

        const { data: body } = data?.data

        const resp = yield call(CallApi.DELETE, `${API_URLS.PROSPECTS.FORCED_DELETE}`, body, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(removeProspectFromList(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
export function* restoreTrashProspectSaga(action) {
    try {
        const data = action.payload;

        const { data: body } = data?.data

        const resp = yield call(CallApi.PATCH, `${API_URLS.PROSPECTS.RESTORE}`, body, data?.token)
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(removeProspectFromList(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}


